/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
export default function Contact() {
    useScrollAnimation();
    return (
        <>
            <section className="landingpages">
                <div className="container h-[75%] flex flex-col gap-[5px] items-center justify-center">
                    <div className="text-white font-bold capitalize text-[40px] btmAni2000">Contact us</div>
                    <div className="flex items-center text-[20px] gap-[4px] text-white btmAni25002">
                        <Link className="text-white" to={"/"}>Home</Link>
                        -
                        <span className="text-white">Contact us</span>
                    </div>
                </div>
            </section>
            <section className="py-[20px]">
                <div className="container flex flex-col gap-[20px]">
                    <div className="flex flex-col gap-[5px] items-center justify-center">
                        <div className="t-center flex items-center justify-center text-[35px] font-bold text-[#294a6a] capitalize btmAni20002">Get in Touch – We’re Here to Help!</div>
                        <p className="w-100 w-[75%] m-auto text-center btmAni3000">
                            At M Power Moving Services, our dedicated team of experts
                            is ready to assist you at every step of your moving journey.
                            We ensure a seamless, stress-free experience with solutions tailored
                            to your unique needs. Contact us today and move with confidence!
                        </p>
                    </div>
                    <form action="https://mpowermoving-services.com/submit_form.php" method="POST">
                        <div class="flex flex-col gap-[15px]">
                            <div class="flex flex-col gap-[8px]">
                                <div class="f-col flex items-center gap-[10px] justify-between">
                                    <div class="w-100 w-[48%] flex flex-col gap-[5px] btmAni2500">
                                        <label class="font-bold text-[20px] text-[#294a6a]">First Name</label>
                                        <input type="text" name="first_name" placeholder="First Name" class="outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]" required />
                                    </div>
                                    <div class="w-100 w-[48%] flex flex-col gap-[5px] btmAni2500">
                                        <label class="font-bold text-[20px] text-[#294a6a]">Last Name</label>
                                        <input type="text" name="last_name" placeholder="Last Name" class="outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]" required />
                                    </div>
                                </div>
                                <div class="f-col flex items-center gap-[10px] justify-between">
                                    <div class="w-100 w-[48%] flex flex-col gap-[5px] btmAni2500">
                                        <label class="font-bold text-[20px] text-[#294a6a]">Email</label>
                                        <input type="email" name="email" placeholder="Your Email" class="outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]" required />
                                    </div>
                                    <div class="w-100 w-[48%] flex flex-col gap-[5px] btmAni2500">
                                        <label class="font-bold text-[20px] text-[#294a6a]">Subject</label>
                                        <input type="text" name="subject" placeholder="How can we help you?" class="outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]" required />
                                    </div>
                                </div>
                                <div class="f-col flex items-center gap-[10px] justify-between">
                                    <div class="w-100 w-[48%] flex flex-col gap-[5px] btmAni2500">
                                        <label class="font-bold text-[20px] text-[#294a6a]">Phone Number</label>
                                        <input type="text" name="phone" placeholder="Your Phone Number" class="outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]" required />
                                    </div>
                                    <div class="w-100 w-[48%] flex flex-col gap-[5px] btmAni2500">
                                        <label class="font-bold text-[20px] text-[#294a6a]">Website</label>
                                        <input type="text" name="website" placeholder="https://example.com" class="outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]" required />
                                    </div>
                                </div>
                                <div class="w-[100%] flex flex-col gap-[5px] btmAni2500">
                                    <label class="font-bold text-[20px] text-[#294a6a]">Message</label>
                                    <textarea name="message" placeholder="Your Message" class="h-[250px] max-h-[350px] outline-none border-[2px] border-[#294a6a] p-[8px] rounded-[4px]"></textarea>
                                </div>
                            </div>
                            <button class="btmAni30002 w-fit bg-[#294a6a] py-[6px] px-[20px] font-bold rounded-[4px] text-white" type="submit">Submit Form</button>
                        </div>
                    </form>
                </div>
            </section>
            <section className="py-[20px]">
                <div className="container flex flex-col gap-[20px]">
                    <div className="js-scroll fade-top flex items-center justify-center text-[35px] font-bold text-[#294a6a] capitalize">Contact us now </div>
                    <div className="f-col flex">
                        <div className="js-scroll fade-top w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/phone.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">Call Now</span>
                                <Link to={"tel:8888906622"}>888-890-6622</Link>
                            </div>
                        </div>
                        <div className="js-scroll fade-btm w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/location.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">Location</span>
                                <Link to={"https://maps.app.goo.gl/mqSCdkcViFQGoZCJ7"}>cudahy Wisconsin, 53110</Link>
                            </div>
                        </div>
                        <div className="js-scroll fade-top w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/email.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">Email</span>
                                <Link to={"mailto:info@mpowermovingservices.com"}>info@mpowermovingservices.com</Link>
                            </div>
                        </div>
                        <div className="js-scroll fade-btm w-100 w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]">
                            <div className="w-[45px] h-[45px] bg-white flex items-center justify-center rounded-full shadow-md">
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/working.svg").default} alt="" />
                            </div>
                            <div className="flex flex-col items-center">
                                <span className="font-bold capitalize">working hours</span>
                                <Link className="flex flex-col" to={""}>
                                    <ul className="list-disc text-center">
                                        <li className="capitalize">Monday to Friday from 10 AM to 5 PM</li>
                                        <li className="capitalize">Saturday 11 AM to 3 PM</li>
                                        <li className="capitalize">Sunday off</li>
                                    </ul>
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        <section className="py-[20px] flex items-center justify-center js-scroll fade-top">
                <img className="w-100 w-[30%] h-full" src={require("../../assets/image/usaMap.svg").default} alt="" />
            </section>
        </>
    );
}